import { Component, OnInit, Input } from '@angular/core'
import { CpmService } from '../../service/cpm.service'
import { ActivatedRoute } from '@angular/router'
import { StoreService } from '../../service/store.service'
import { Subscription } from 'rxjs/Subscription'

@Component({
  selector: 'app-ipo-executive-summary',
  templateUrl: './ipo-executive-summary.component.html',
  styleUrls: ['./ipo-executive-summary.component.scss']
})
export class IpoExecutiveSummaryComponent implements OnInit {
  @Input() companyProfile: any
  @Input() isFullFactSheet
  @Input() printPage
  subscription: Subscription
  isIpoExsum = true
  establishmentDate
  listingDate
  ipoPrice
  fundManagerNameThai
  finAdvisorNameThai = []
  finAdvisorName
  finAdvisor = []
  bahtUnit = '  บาท'
  assetManagerNameThai
  trusteeThai
  initialPar
  par
  companyNameThai

  constructor(
    private cpmService: CpmService,
    private activatedRoute: ActivatedRoute,
    private store: StoreService
  ) {}

  ngOnInit() {
    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(response => {
        if (!response) {
          return
        }
        this.establishmentDate = response['establishmentDate']
        this.listingDate = response['listingDate']
        this.ipoPrice = response['ipoPrice']
        this.par = response['par']
        this.companyNameThai = response['companyNameThai']
        this.finAdvisor = response['finAdvisor']
        this.initialPar = response['initialPar']
        this.companyProfile = response

        this.finAdvisorNameThai = []
        this.finAdvisor.map((obj, i) => {
          this.finAdvisorNameThai.push([obj.finAdvisorNameThai])
        })
        const advisorName = this.finAdvisorNameThai.join(' / ')
        this.finAdvisorName = advisorName

        this.fundManagerNameThai = response['fundManagerNameThai']
        this.assetManagerNameThai = response['assetManagerNameThai']
        this.trusteeThai = response['trusteeThai']
      })
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/ipo-executive-summary/ipo-executive-summary.component.ts